import Icon from "app/components/shared/Icon";
import { ResultButtons } from ".";

const SortingButton = ({
  updateSort,
  buttonType,
  currentSort,
  currentOrder,
}) => {
  return (
    <button
      onClick={updateSort}
      style={{
        fontWeight: currentSort === buttonType ? "bold" : "normal",
        lineHeight: 2,
      }}
      id={`button-${currentOrder ? "DESC" : "ASC"}`}
    >
      {ResultButtons[buttonType]}
      {currentSort === buttonType && (
        <span>
          <Icon
            icon="heroicons/outline/chevron-down"
            style={{
              marginLeft: "4px",
              width: "10px",
              display: "inline-block",
              rotate: currentOrder ? "0deg" : "180deg",
            }}
          />
        </span>
      )}
    </button>
  );
};

export default SortingButton;
